export default "__VITE_ASSET__Cbwy3hbE__"